import { render, staticRenderFns } from "./ProlongDialog.vue?vue&type=template&id=4655d95c&scoped=true"
import script from "./ProlongDialog.vue?vue&type=script&lang=js"
export * from "./ProlongDialog.vue?vue&type=script&lang=js"
import style0 from "./ProlongDialog.vue?vue&type=style&index=0&id=4655d95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655d95c",
  null
  
)

export default component.exports